module.exports = __webpack_public_path__ + "static/img/8668_phase_function_Paper_Points.757cd0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8668_phase_function_Paper_Points.png
// module id = Rbst
// module chunks = 0